var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpeed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#544C40",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "800px",
    height: "800px",
    viewBox: "0 0 982.677 982.676",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M815.334,307.738c-44.1-38.1-93.9-67.8-148.2-88.3c-56.1-21.3-115.3-32.1-175.799-32.1c-60.5,0-119.7,10.8-175.8,32.1 c-54.2,20.6-104.1,50.3-148.2,88.3c-89,76.9-148,182.8-166,298.4c-5,31.9,4.2,64.2,25.1,88.7s51.4,38.5,83.5,38.5h281.2 c18.4,36.7,56.4,62,100.2,62c43.799,0,81.799-25.3,100.2-62h281.2c32.199,0,62.6-14,83.5-38.5c21-24.5,30.1-56.8,25.1-88.7 C963.334,490.539,904.334,384.638,815.334,307.738z M491.334,725.338c-16.5,0-30.8-9.6-37.7-23.4c-2.8-5.6-4.3-11.899-4.3-18.6 c0-23.2,18.8-42,42-42c13.7,0,25.9,6.6,33.5,16.7c5.3,7,8.5,15.8,8.5,25.3C533.334,706.539,514.534,725.338,491.334,725.338z  M880.234,629.838c-1.4,1.6-3.801,3.5-7.5,3.5h-281.2c-18.4-36.7-56.4-62-100.2-62c-3.2,0-6.4,0.1-9.6,0.4l-128.4-169.601 c-22-29-66.9-1.3-50.9,31.4l93.601,191c-1.8,2.8-3.4,5.8-4.9,8.8h-281.2c-3.8,0-6.2-1.9-7.5-3.5c-1.4-1.6-2.9-4.4-2.3-8.2 c14.4-92.2,61.5-176.8,132.6-238.2c35.2-30.4,75-54.1,118.3-70.5c32.3-12.3,66-20.1,100.399-23.6v81.2c0,22.1,17.9,40,40,40 c22.1,0,40-17.9,40-40v-81.2c34.4,3.4,68,11.3,100.4,23.6c43.3,16.4,83.1,40.1,118.3,70.5c71.101,61.4,118.2,146,132.601,238.2 C883.134,625.539,881.634,628.239,880.234,629.838z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeed);
export default __webpack_public_path__ + "static/media/speed.d18382ff4abb11aec71eb09ddfd3b6d6.svg";
export { ForwardRef as ReactComponent };